function NotFound(){
    return(
        <div className="pt-[139px]">
            <div className="py-[240px]">
                <h2 className="text-[32px] lg:text-[48px] font-semibold">404 - Page Not Found</h2>
                <p className="text-[16px] text-grey">Sorry, the page you are looking for does not exist.</p>
            </div>
        </div>
    )
}

export default NotFound